export interface IQuery { }

export class AuthUserWorkspacesEntriesQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Workspaces.Queries.AuthUserWorkspacesEntriesQueryV1, TCh.Domain.Organizations'


	constructor ()
	{
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Workspaces.Queries.AuthUserWorkspacesEntriesQueryV1, TCh.Domain.Organizations'
	}

}

export class AuthUserWorkspacesQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Workspaces.Queries.AuthUserWorkspacesQueryV1, TCh.Domain.Organizations'


	constructor ()
	{
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Workspaces.Queries.AuthUserWorkspacesQueryV1, TCh.Domain.Organizations'
	}

}

export class WorkspaceDetailsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Workspaces.Queries.WorkspaceDetailsQueryV1, TCh.Domain.Organizations'

	WorkspaceId: string

	constructor (workspaceId: string)
	{
		this.WorkspaceId = workspaceId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Workspaces.Queries.WorkspaceDetailsQueryV1, TCh.Domain.Organizations'
	}

}

export class WorkspaceInvitationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Workspaces.Queries.WorkspaceInvitationQueryV1, TCh.Domain.Organizations'

	Token: string

	constructor (token: string)
	{
		this.Token = token
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Workspaces.Queries.WorkspaceInvitationQueryV1, TCh.Domain.Organizations'
	}

}

export class WorkspaceMembersQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Workspaces.Queries.WorkspaceMembersQueryV1, TCh.Domain.Organizations'

	WorkspaceId: string

	constructor (workspaceId: string)
	{
		this.WorkspaceId = workspaceId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Workspaces.Queries.WorkspaceMembersQueryV1, TCh.Domain.Organizations'
	}

}

export class WorkspacesByOrganizationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Workspaces.Queries.WorkspacesByOrganizationQueryV1, TCh.Domain.Organizations'

	TenantId: number

	constructor (tenantId: number)
	{
		this.TenantId = tenantId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Workspaces.Queries.WorkspacesByOrganizationQueryV1, TCh.Domain.Organizations'
	}

}

export class WorkspacesByUserQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Workspaces.Queries.WorkspacesByUserQueryV1, TCh.Domain.Organizations'

	UserId: string

	constructor (userId: string)
	{
		this.UserId = userId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Workspaces.Queries.WorkspacesByUserQueryV1, TCh.Domain.Organizations'
	}

}

